import { Component, Input, OnInit } from '@angular/core';
import { ChatroomService } from 'src/app/services/chatroom.service';

@Component({
  selector: 'app-chat-popup-button',
  templateUrl: './chat-popup-button.component.html',
  styleUrls: ['./chat-popup-button.component.scss'],
})
export class ChatPopupButtonComponent implements OnInit {
  @Input() user_id: string;
  @Input() username: string;
  @Input() email: string;
  @Input() isLoading: boolean;

  valid_user: boolean;
  isChatOpen = false;

  constructor(private chatroomService: ChatroomService) {}

  ngOnInit() {
    this.valid_user = this.chatroomService.validateUser(this.username, this.email);
  }

  goToChatroomPage() {
    this.chatroomService.goToChatroomPage(this.username, this.email);
  }
}
